import React from 'react'
import BasePhoneInput from 'react-phone-input-2'
import useStyles from './styles'

const PhoneInput = ({
  value,
  isValid,
  onChange,
  borderless,
  fontSize,
  autoWidth,
  inputClass,
  opacity,
  name,
  id = undefined,
  noMarginLeft = false,
  inputHeight = '30',
  ...props
}) => {
  const handleOnChange = React.useCallback(
    (val, data, event, formattedValue) => {
      onChange && onChange(val)
    },
    [onChange]
  )

  const getLocale = React.useCallback(() => {
    try {
      const lang = navigator.language.split('-')[1]
      return lang.toLowerCase()
    } catch (error) {
      console.error('Could not get browser locale, using fallback')
      return 'us'
    }
  }, [])

  const classes = useStyles({
    borderless,
    fontSize,
    autoWidth,
    opacity,
    noMarginLeft,
    inputHeight
  })

  return (
    <BasePhoneInput
      containerClass={classes.container}
      country={getLocale()}
      isValid={isValid}
      onChange={handleOnChange}
      value={value}
      enableSearch
      disableSearchIcon
      prefix=''
      inputClass={inputClass}
      inputProps={{ name: name, id }}
      {...props}
    />
  )
}

export default PhoneInput
